var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"title",rawName:"v-title"}],staticClass:"home",attrs:{"data-title":_vm.title}},[_c('bannera'),_c('div',{staticClass:"box"},[_c('contenta')],1),_c('footera')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }